import { render, staticRenderFns } from "./GradingRuleCreate.vue?vue&type=template&id=7672154c"
import script from "../../controllers/grading_setting/grading-rule-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading_setting/grading-rule-create.js?vue&type=script&lang=js&external"
import style0 from "./GradingRuleCreate.vue?vue&type=style&index=0&id=7672154c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports